<template>
  <div :class="panelMode && 'd-flex flex-column gap-3'">
    <Traveller
      v-for="(traveller, index) in orderedTravellers"
      :key="`${traveller.birthday}-${index}`"
      :panelMode="panelMode"
      :traveller="traveller"
      :traveller-index="index"
      :departure-date="departureDate"
    />
  </div>
</template>

<script lang="ts" setup>
  // Vue
  import { defineProps, computed, ComputedRef } from 'vue'

  // Types
  import { TravellerSummary } from '@/services/BookingService.interface'

  // Components
  import Traveller from './Traveller.vue'

  // Props
  interface Props {
    travellers: TravellerSummary[]
    departureDate?: string
    panelMode?: boolean
  }
  const props = defineProps<Props>()

  // Computed

  // Orded travellers by age
  const orderedTravellers: ComputedRef<TravellerSummary[]> = computed(() => {
    return props.travellers
      .slice()
      .sort((travellerA: TravellerSummary, travellerB: TravellerSummary) => {
        return (
          new Date(travellerA.birthday).getTime() -
          new Date(travellerB.birthday).getTime()
        )
      })
  })
</script>
